import { inject as service } from '@ember/service';
import { Command } from 'command-palette/command';
import command from 'command-palette/decorators/command';
import { bold } from 'command-palette/utils/command-helpers';

import { TEXT_POST_TYPE } from 'later/utils/constants';
import { getProfile } from 'later/utils/global-search/get-profile';
import { convert, timestamp } from 'later/utils/time-format';

import type RouterService from '@ember/routing/router-service';
import type StoreService from '@ember-data/store';
import type { SearchCommandQuery } from 'command-palette/types';
import type AuthService from 'later/services/auth';
import type SelectedSocialProfilesService from 'later/services/selected-social-profiles';

@command('schedule-to-profile')
export class ScheduleToProfileCommand extends Command {
  @service declare auth: AuthService;
  @service declare store: StoreService;
  @service declare router: RouterService;
  @service declare selectedSocialProfiles: SelectedSocialProfilesService;

  public searchTerms = ['schedule', 'post', 'publish', 'draft', 'make', 'create', 'media', 'profile', 'calendar'];

  protected action(query: SearchCommandQuery): void | Promise<void> {
    const profile = getProfile({ auth: this.auth, store: this.store, query });
    const TIME_OFFSET_MIN = 30;
    const scheduledTime = timestamp() + convert.minutes(TIME_OFFSET_MIN).toSeconds();
    this.selectedSocialProfiles.selectExactly([profile]);
    this.router.transitionTo('cluster.schedule.calendar.post.new', TEXT_POST_TYPE, {
      queryParams: {
        scheduledTime
      }
    });
  }

  public isSuggested(): boolean {
    return true;
  }

  public getTitle(): string {
    return `Schedule Post`;
  }

  public getDescription(query: SearchCommandQuery): string {
    const profile = getProfile({ auth: this.auth, store: this.store, query });
    const displayName = profile?.displayName;
    return `Schedule a post to ${bold(displayName)}`;
  }

  public getIcon(query: SearchCommandQuery): string {
    const profile = getProfile({ auth: this.auth, store: this.store, query });
    const icon = profile?.get('profileType') ? `social-${profile.get('profileType')}` : 'calendar';

    return icon;
  }
}

export default ScheduleToProfileCommand;
